import '../styles/index.scss';
// import '@images/favicon.ico';
// import 'airbnb-browser-shims';

/* eslint-disable no-undef */
/* eslint-disable */

// General
// Your code goes here...
import './site/menu';
import './site/mansory';
import './site/filter-sidebar';
// import './site/loader/';
import './site/fancybox';
import './site/position';
import './site/accordion';
import './site/tags-page';
import './site/trim-words';
import './site/related-bar';
import './site/form-modal';
import './site/web-stories';

// // Sliders
import './site/slide-default';
import './site/slide-category';
import './site/slide-related-content';
import './site/filter-provider';

// cta
import './site/cta';

// const svgModules = require.context('@icons', false, /\.svg$/);
// svgModules.keys().forEach(svgModules);

